import { render, staticRenderFns } from "./FlowSettings.vue?vue&type=template&id=6366355d&scoped=true&"
import script from "./FlowSettings.vue?vue&type=script&lang=js&"
export * from "./FlowSettings.vue?vue&type=script&lang=js&"
import style0 from "./FlowSettings.vue?vue&type=style&index=0&id=6366355d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6366355d",
  null
  
)

export default component.exports